import { get } from "lodash";
import PoweredbyLennd from "../PoweredbyLennd";
import { Span, Div } from "components/Base";
import AccountsList from "./AccountsList";
import React, { useState, useEffect } from "react";
import CSSModules from "react-css-modules";
import css from "./styles.scss";
import Loading from "components/Global/Loading";
import * as R from "ramda";
import { Link } from "react-router";

const PortalSwitch = props => {
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const portalUserResult = await props.getPortalUser({
        userId: props.user.id,
        eventId: props.params.portalId
      });

      if (!portalUserResult) {
        setError("You do not have access to this event portal.");
      }
    };

    if (props.getPortalUser) {
      fetchData().then(() => {});
    }
  }, [props.getPortalUser]);

  const updateActiveView = activeViewId => {
    props
      .updatePortalUser({
        eventId: props.portal.event.id,
        userId: props.portalUser.user_id,
        activeView: activeViewId
      })
      .then(() => {
        window.location = `/portals/${props.portal.event.slug}/${props.portal.event.uuid}`;
      });
  };

  const {
    portal = {},
    portalUser = {},
    accounts = [],
    params: { portalId = "" }
  } = props;
  const name = portalUser.user_fname
    ? `${portalUser.user_fname} ${portalUser.user_lname}`
    : portalUser.user_email;
  const accountsList = accounts.map(account => ({
    id: account.id,
    name: account.name,
    typeName: get(account, "type.name", "") || get(account, "record_type", ""),
    typeColor: get(account, "type.text_color", ""),
    backgroundColor: get(account, "type.background_color", "#dadada"),
    photoUrl: account.photo_url,
    icon: get(account, "type.icon"),
    onClick: () => updateActiveView(account.id)
  }));

  return (
    <div styleName="container">
      <div
        styleName="background"
        style={{ backgroundImage: `url('${portal.background_image_url}')` }}
      />
      <div styleName="panel">
        <div styleName="brandingWrapper">
          <div styleName="branding">
            <img
              styleName="brandImage"
              src={portal.event.logo_image_url}
              alt=""
            />
          </div>
        </div>
        <div styleName="list">
          {error ? (
            <Div color="gray6" fs={3} py={3}>
              You do not have access this event portal. If you need access,
              please contact your event point of contact.
            </Div>
          ) : (
            <>
              <div styleName="heading">Continue as:</div>
              {!R.isEmpty(portalUser) ? (
                <AccountsList
                  accounts={accountsList}
                  onUserClick={() => updateActiveView(portalUser.user_id)}
                  userPhotoUrl={portalUser.user_photo_url}
                  name={name}
                  userName={[portalUser.user_fname, portalUser.user_lname]
                    .filter(v => v)
                    .join(" ")}
                />
              ) : (
                <Loading content={"Loading options..."} />
              )}
            </>
          )}

          <Div display="column" mt={4} pt={4} bt={1} color="gray3">
            <Div fs={2} color="gray6">
              Logged in as {name}{" "}
            </Div>
            <Link
              onlyActiveOnIndex={true}
              to={`/logout?returnTo=/portal-login/${portal.event.slug}/${portalId}`}
            >
              <Span
                color={{ default: "gray5", hover: "gray3" }}
                underline
                transition="fast"
                fs={2}
              >
                Logout
              </Span>
            </Link>
          </Div>
        </div>
      </div>
      <PoweredbyLennd />
    </div>
  );
};

export default CSSModules(PortalSwitch, css);
